import { render, staticRenderFns } from "./DisplayBoolean.vue?vue&type=template&id=3935d5cf&"
import script from "./DisplayBoolean.vue?vue&type=script&lang=ts&"
export * from "./DisplayBoolean.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3935d5cf')) {
      api.createRecord('3935d5cf', component.options)
    } else {
      api.reload('3935d5cf', component.options)
    }
    module.hot.accept("./DisplayBoolean.vue?vue&type=template&id=3935d5cf&", function () {
      api.rerender('3935d5cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DisplayBoolean/DisplayBoolean.vue"
export default component.exports